import React from 'react';

import { useMileageFilter } from '@/hooks/filters/mileage-filter.hook';
import { useYearsFilterHook } from '@/hooks/filters/years-filter.hook';

import { MileageFilter } from './components/mileage-filter/mileage-filter';
import { YearsFilter } from './components/years-filter/years-filter';
import styles from './years-mileage.module.scss';

export const YearsMileage: React.FC = () => {
  const { yearsFilterDefault } = useYearsFilterHook();
  const { mileageFilterDefault } = useMileageFilter();

  return (
    <div className={styles.yearsMileage}>
      <YearsFilter yearsFilterDefault={yearsFilterDefault} />
      <MileageFilter mileageFilterDefault={mileageFilterDefault} />
    </div>
  );
};
